import { render, staticRenderFns } from "./ProfileDrafts.vue?vue&type=template&id=ec5fb308&"
import script from "./ProfileDrafts.vue?vue&type=script&lang=js&"
export * from "./ProfileDrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports